import BookDemoForm from '../BookDemoForm';

const BookDemo = () => {
  return (
    <div className='grid grid-cols-1 place-items-center pb-32'>
      <h2 className='mobile:text-lg text-center text-xl'>Kom igång</h2>
      <p className='font-display tablet:text-3xl mobile:text-2xl mt-1 mb-10 text-center text-4xl'>Bli kund idag!</p>
      <BookDemoForm />
    </div>
  );
};

export default BookDemo;
